import { render, staticRenderFns } from "./layout3-comp1.vue?vue&type=template&id=442509af&"
import script from "./layout3-comp1.vue?vue&type=script&lang=js&"
export * from "./layout3-comp1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports